import { render, staticRenderFns } from "./questionnaireResult.vue?vue&type=template&id=895ff966&scoped=true&"
import script from "./questionnaireResult.vue?vue&type=script&lang=js&"
export * from "./questionnaireResult.vue?vue&type=script&lang=js&"
import style0 from "./questionnaireResult.vue?vue&type=style&index=0&id=895ff966&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895ff966",
  null
  
)

export default component.exports